import { z } from 'zod'
import { fallback } from '../../../../utilities/zod-utils'

const fallbackData = {
	offset: { x: 0, y: 0 },
	rotation: 0,
	scale: 1, // only used for the positioning of images within their containers
	// flipX: false,
	// flipY: false,

	// width: 'auto' // or a number
	// height: 'auto' // or a number
} as const

const offsetSchema = z.object({
	x: z.number(),
	y: z.number(),
}).or(fallback(fallbackData.offset))
const rotationSchema = z.number().or(fallback(fallbackData.rotation))
const scaleSchema = z.number().or(fallback(fallbackData.scale))

export const metaTransformSchema = z.object({
	offset: offsetSchema,
	rotation: rotationSchema,
	scale: scaleSchema,
}).or(fallback(fallbackData))

export const metaTransformDefault: MetaTransformConfiguration = metaTransformSchema.parse({})

export type MetaTransformConfiguration = z.infer<typeof metaTransformSchema>
